/**
 * SeverityLegend Component
 * Displays information about severity levels for racking inspections
 */
import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { SEVERITY_LEVELS } from "../constants";
import { useTheme } from "../../../theme";

interface SeverityLegendProps {
  title?: string;
}

/**
 * Component to display severity levels and their descriptions
 * @param props Component properties
 * @returns SeverityLegend component
 */
const SeverityLegend: React.FC<SeverityLegendProps> = ({
  title = "Severity",
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <View style={[styles.table, isDark && { borderColor: colors.border.default }]}>
      {/* Header Row */}
      <View style={styles.headerRow}>
        <Text style={styles.fullHeaderCell}>{title}</Text>
      </View>

      {/* Data Rows */}
      {SEVERITY_LEVELS.map((level, index) => (
        <View key={index} style={[styles.row, isDark && { borderColor: colors.border.default }]}>
          <Text style={[styles.cellTitle, isDark && { color: colors.text.inverse, borderColor: colors.border.default }]}>{level.title}</Text>
          <Text style={[styles.cellDesc, isDark && { color: colors.text.secondary }]}>{level.description}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  table: {
    marginTop: 20,
    borderWidth: 1,
    borderColor: "#000",
  },
  headerRow: {
    flexDirection: "row",
  },
  fullHeaderCell: {
    flex: 1,
    textAlign: "center",
    padding: 10,
    backgroundColor: "#77ab59",
    color: "#fff",
    fontWeight: "bold",
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  cellTitle: {
    width: "30%",
    padding: 8,
    borderRightWidth: 1,
    borderColor: "#000",
    fontWeight: "bold",
  },
  cellDesc: {
    width: "70%",
    padding: 8,
  },
});

export default SeverityLegend;
